import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const GatewayIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M2.35334 17.7616C2.65643 18.1068 3.19484 18.1541 3.55854 17.8699C3.92224 17.5823 3.97216 17.0714 3.67264 16.7262C2.44605 15.322 1.71152 13.522 1.71152 11.5561C1.71152 9.59019 2.44962 7.79011 3.67264 6.38591C3.97216 6.04078 3.92224 5.52647 3.55854 5.24224C3.19485 4.95802 2.65286 5.00539 2.35335 5.35052C0.884287 7.03556 2.03325e-07 9.20108 0 11.5561C-2.03325e-07 13.9111 0.884286 16.0766 2.35334 17.7616Z"
            fill="currentColor"
         />
         <path
            d="M3.99712 11.5561C3.99712 12.9332 4.48918 14.2021 5.31642 15.2104C5.60881 15.5657 6.14366 15.6299 6.51805 15.3525C6.89245 15.075 6.95663 14.5675 6.66781 14.2122C6.06521 13.478 5.70864 12.5576 5.70864 11.5561C5.70864 10.5545 6.06521 9.63418 6.66781 8.89993C6.95663 8.54466 6.89245 8.03373 6.51805 7.75965C6.14366 7.48558 5.60524 7.54649 5.31642 7.90177C4.48918 8.91009 3.99712 10.1789 3.99712 11.5561Z"
            fill="currentColor"
         />
         <path
            d="M21.6467 5.35039C21.3436 5.00526 20.8052 4.95789 20.4415 5.24211C20.0778 5.52972 20.0278 6.04064 20.3274 6.38577C21.5539 7.78997 22.2885 9.59006 22.2885 11.5559C22.2885 13.5218 21.5504 15.3219 20.3274 16.7261C20.0278 17.0712 20.0778 17.5855 20.4415 17.8698C20.8052 18.154 21.3471 18.1066 21.6467 17.7615C23.1157 16.0764 24 13.9109 24 11.5559C24 9.20094 23.1157 7.03543 21.6467 5.35039Z"
            fill="currentColor"
         />
         <path
            d="M20.0029 11.5559C20.0029 10.1788 19.5108 8.90995 18.6836 7.90163C18.3912 7.54635 17.8563 7.48206 17.4819 7.75952C17.1075 8.03698 17.0434 8.54452 17.3322 8.8998C17.9348 9.63404 18.2914 10.5544 18.2914 11.5559C18.2914 12.5575 17.9348 13.4778 17.3322 14.2121C17.0434 14.5674 17.1075 15.0783 17.4819 15.3524C17.8563 15.6264 18.3948 15.5655 18.6836 15.2102C19.5108 14.2019 20.0029 12.9331 20.0029 11.5559Z"
            fill="currentColor"
         />
         <path
            d="M12.1967 10.2566C13.2603 10.2566 14.1225 11.1297 14.1225 12.2066C14.1225 13.0553 13.5861 13.7744 12.8387 14.0424V18.0566H11.5548V14.0424C10.8074 13.7744 10.2709 13.0553 10.2709 12.2066C10.2709 11.1297 11.1331 10.2566 12.1967 10.2566Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default GatewayIcon
